import React from "react";


const HamburgerIcon = props => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="24" viewBox="0 0 32 24">
            <g id="Group_687" data-name="Group 687" transform="translate(-7204.5 2829.5)">
                <line id="Line_5" data-name="Line 5" x2="29" transform="translate(7206 -2828)" fill="none" stroke="#172951" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                <line id="Line_6" data-name="Line 6" x2="29" transform="translate(7206 -2818)" fill="none" stroke="#172951" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                <line id="Line_7" data-name="Line 7" x2="29" transform="translate(7206 -2808)" fill="none" stroke="#172951" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
            </g>
        </svg>
    );

}

export default HamburgerIcon;